<template>
    <div v-if="currentQuestion">
        <div class="mt-4">
            <div v-html="currentQuestion.content"></div>
        </div>

        <form @submit.prevent="submitAnswer" v-if="currentQuestion?.options?.length > 0">
<!--            <h5 class="mb-0 mt-3">{{ currentQuestion.question }}</h5>-->

            <div class="mt-1">
                <div class="mt-4 list-group" :class="{'list-group-flush' : currentQuestion.answer == null}">
                    <label class="list-group-item m-0 p-3 d-flex justify-content-between position-relative" v-for="option in currentQuestion.options" :key="option.id">
                        <div>
                            <input class="form-check-input me-2" type="radio" :id="'option' + option.id"
                                   :name="'option' + currentQuestion.id" :value="option.id"
                                   :checked="currentAnswerId === option.id"
                                   @change="updateAnswerId(option.id)" v-if="type != 'one'" >
                            <label class="form-check-label m-0" :for="'option' + option.id">{{ option.text }}</label>
                        </div>

                        <span class="score-badge badge rounded-pill pt-2"
                              v-if="currentQuestion.answer != null && option.percentage != null"
                              :class="{ 'text-bg-success': option.is_correct, 'text-bg-danger': !option.is_correct }">
                            {{ option.percentage }}%
                        </span>

                        <div class="progress position-absolute h-100 w-100 rounded-0"
                             :style="{'top': '0', 'left': 0, 'opacity': 0.2}" v-if="currentQuestion.answer != null">
                            <div class="progress-bar"
                                 role="progressbar" :style="{width: (option?.percentage ?? 0) + '%'}"
                                 :aria-valuenow="option?.percentage ?? 0"
                                 aria-valuemin="0" aria-valuemax="100"
                                 :class="{ 'bg-success': option.is_correct, 'bg-danger': !option.is_correct }">
                            </div>
                        </div>
                    </label>
                </div>
            </div>
                <div class="col-lg-12 mt-2 mb-0">

                    <div class="d-flex align-items-center gap gap-2">
                        <button class="btn btn-primary" :disabled=" ! showSubmitButton() || answer_submitted === true ">
                            Submit answer
                        </button>


                        <div class="dropdown dropdown-primary" v-if="answer_submitted === true">
                            <button type="button" class="btn btn-icon btn-soft-primary dropdown-toggle p-0"
                                    @click="nextQuestion" :disabled="isLastQuestion" >
                                <i class="ti ti-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
        </form>

        <div class="mt-4" v-if="currentQuestion.answer != null">

            <div class="mb-3" v-html="currentQuestion.explanation" v-if="type !== 'mock_exams' || isEnd() "></div>

            <div class="mb-3">
                <div class="btn-group" role="group">
                    <div class="btn btn-outline-secondary p-1">
                        <RatingButtons :id="currentQuestion.id"
                                       type="question"
                                       :icons_type="'hands'"
                                       :difference="currentQuestion?.likes?.difference"
                                       :user_like="currentQuestion?.user_like"
                                       @update:user_like="currentQuestion.user_like = $event"
                        />
                    </div>

                    <button type="button" data-bs-toggle="offcanvas"
                            data-bs-target="#discuss_question"
                            aria-controls="discuss_question" class="btn btn-outline-secondary"
                            v-if="type !== 'mock_exams'"
                    >
                        <i class="ti-comments-smiley"></i>
                         Discuss ({{ currentQuestion.discussions_count ?? 0 }})
                    </button>

                    <button class="btn btn-outline-secondary collapsed" type="button"
                            data-bs-toggle="collapse" data-bs-target="#collapseImprove" aria-expanded="false"
                            aria-controls="collapseImprove">
                        <i class="ti ti-comments"></i> Improve
                    </button>
                </div>
            </div>

            <discussQuestion :question="currentQuestion" v-if="type !== 'mock_exams'"></discussQuestion>
            <suggestion :question="currentQuestion"></suggestion>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import RatingButtons from "../share/RatingButtons.vue";
import discussQuestion from "./discuss_question.vue";
import Suggestion from "../question_suggestion/suggestion.vue";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    props: {
        currentQuestion: Object,
        isLastQuestion: Boolean,
        currentAnswerId: Number,
        type: String,
        isEnd: {
        }
    },
    data() {
        return {
            answer_submitted: false
        };
    },
    watch: {
        currentQuestion(newVal, oldVal) {
            if(newVal?.id !== oldVal?.id) {
                this.answer_submitted = false;
            }
        },
    },
    components: {RatingButtons, discussQuestion, Suggestion},
    methods: {
        showSubmitButton() {
            if (
                ( ! this.isEnd() && this.type === 'mock_exams')// فى الامتحانات الجاهزة الوقت عامل مهم لإنهاء الاختبار
                ||
                this.type === 'session'
            ) {
                if (this.type === 'mock_exams') {
                    // تأكد من أن السؤال الحالي ليس لديه إجابة
                    return Object.keys(this.currentQuestion?.answer ?? {}).length === 0;
                } else {
                    // فى حالة عرض السؤال كبيانات عادية بدون اكشن فمش بنظهر الازرار
                    return this.type !== 'one';
                }
            }
            return false;
        },
        updateAnswerId(id) {
            this.$emit('update:currentAnswerId', id);
        },
        nextQuestion() {
            this.$emit('update:nextQuestion');
        },
        submitAnswer() {
            const id = toast.info('Submitting answer...', {icon: 'fa-solid fa-cloud-arrow-up'});
            const formData = new FormData();
            formData.append('answer_id', this.currentAnswerId);
            formData.append('question_id', this.currentQuestion.id);

            if (this.type === 'mock_exams') {
                formData.append('exam_id', this.$route.params?.exam_id);
                formData.append('subscribe_id', this.$route.params?.subscribe_id);
            } else {
                formData.append('session_id', this.$route.params?.session_id || null);
            }

            const that = this;
            formData.append('subscribe_id', this.$route.params?.subscribe_id || null);

            axios.post(
                this.type === 'mock_exams' ? 'student_exam_answers' : 'student_answers', formData
            ).then(response => {
                that.answer_submitted = true;
                toast.dismiss(id);
                toast.success(response.data.message, {timeout: 3000, icon: 'fa-solid fa-circle-check'});
                this.$emit('update:currentQuestion', {
                    ...this.currentQuestion,
                    answer: response.data.data,
                    options: response.data.options
                });
            }).catch(error => {
                toast.dismiss(id);
                if (error.response) {
                    toast.error(error.response.data.message, {timeout: 3000, icon: 'fa-solid fa-circle-exclamation'});
                }
            });
        }
    }
};
</script>

<style scoped>
/* Add any styles specific to the current question here */
</style>
